import React, { useEffect, useState } from "react";
import Component from "../../components";
import { useLocation, useNavigate } from 'react-router-dom';
import _ from "lodash";
const NewPassword = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (_.isEmpty(state)) {
      navigate('/login');
    }
  }, [])
  return (
    <div>
      <Component.CardCarousel />
      <Component.CardNewPassword id={state?.id} />
    </div>
  );
};

export default NewPassword;
